import React from "react";
import { Phone, Siren } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { CONTACT_INFO } from "../lib/data";

export const EmergencyBanner = () => {
  const { t } = useLang();
  return (
    <div
      data-testid="emergency-call-banner"
      className="w-full bg-[#0022FF] text-white text-xs sm:text-sm"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 sm:gap-3">
          <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-rose-500/90">
            <Siren className="h-3 w-3" />
          </span>
          <span className="font-semibold tracking-wide uppercase text-[10px] sm:text-xs">
            {t.emergency.label}
          </span>
          <span className="hidden md:inline opacity-80">·</span>
          <span className="hidden md:inline opacity-90">{t.emergency.text}</span>
        </div>
        <a
          href={`tel:${CONTACT_INFO.phoneClean}`}
          data-testid="emergency-banner-call"
          className="flex items-center gap-2 font-semibold hover:text-sky-300 transition-colors"
        >
          <Phone className="h-3.5 w-3.5" />
          <span>{t.emergency.cta}</span>
        </a>
      </div>
    </div>
  );
};
